<template>
  <div class="gzh-reply">
    <div class="module-item-style">
      <div class="module-item-title">自动回复</div>
      <div class="join-tips">当你的公众号被关注后自动回复一条消息给你的订阅用户</div>
      <div class="reply-container">
        <div class="reply-text" v-if="replyData.type == 'text'">{{replyData.content}}</div>
        <div class="reply-image" v-if="replyData.type == 'image'">
          <img :src="replyData.content" alt="">
        </div>
      </div>
      <div>
        <span class="wl-btn" v-if="replyData.content" @click="editReply"><i class="el-icon-plus" style="font-weight: bold;margin-right: 5px;"></i>编辑</span>
        <span class="wl-btn" v-else @click="addReply"><i class="el-icon-plus" style="font-weight: bold;margin-right: 5px;"></i>添加</span>

      </div>
    </div>

    <div class="module-item-style">
      <div class="module-item-title">关键词自动回复规则</div>
      <div class="join-tips">当订阅用户的行为符合关键词自动回复规则，公众号会自动回复一条消息给订阅用户</div>
      <div>
        <span class="wl-btn" @click="addKeywordsRule"><i class="el-icon-plus" style="font-weight: bold;margin-right: 5px;"></i>添加关键词规则</span>
      </div>
      <ul class="rules-container">
        <li class="rules-item" v-for="(item, i) in rules" :key="item.ruleId">
          <div class="rule-item-title-container">
            <div class="rule-name">
              {{item.name}}
            </div>
            <div class="rule-edit-btn" @click="editRuels(item)"><i class="el-icon-edit-outline" style="margin-right: 5px;"></i>修改</div>
          </div>
          <div class="rule-keywords">
            <el-tag
                class="keywords-item"
                v-if="item.keyName.length > 1"
                v-for="(keyword,index) in item.keyName"
                :key="keyword.keyId"
                @close="delKeywords(keyword.keyId,item.ruleId)"
                closable
                type="info">
              {{keyword.keyName}}
            </el-tag>
            <el-tag
                class="keywords-item"
                v-else
                v-for="(keyword,index) in item.keyName"
                :key="keyword.keyId"
                type="info">
              {{keyword.keyName}}
            </el-tag>
          </div>
          <div class="rule-content-container">
            <div class="rule-text" v-if="item.ruleContextTypeName == 'text'">{{item.ruleContext}}</div>
            <div class="rule-image" v-else>
              <img :src="item.ruleContext" alt="">
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!--    添加回复弹窗-->
    <el-dialog
        class="reply-dialog"
        :title="dialogReplyTitle"
        width="570px"
        @close="replyDialogClose"
        :visible.sync="dialogVisibleReply">
      <el-radio-group v-model="replyType" style="margin-bottom: 30px;" @change="replyTypeChange">
        <el-radio-button label="text">文字</el-radio-button>
        <el-radio-button label="image">图片</el-radio-button>
      </el-radio-group>

      <div class="reply-content-container">
        <el-input
            v-if="replyType == 'text'"
            class="content-text"
            type="textarea"
            rows="10"
            resize="none"
            maxlength="500"

            show-word-limit
            placeholder="请输入内容"
            v-model="replyContent">
        </el-input>
        <div class="content-image" v-if="replyType == 'image'">
          <div class="upload-container" @click="replyUpload" v-if="replyContent == ''">
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <input type="file" ref="replyFileInput" @change="replyFileChange" style="display: none;">
          </div>
          <div v-else class="img-url">
            <i class="el-icon-circle-close img-del" @click="deImg"></i>
            <img :src="replyContent" alt="">
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span v-if="dialogReplyType == 'edit'" class="dialog-del-btn" @click="delReply"><i class="el-icon-delete"></i>删除</span>
        <el-button @click="replyDialogClose">取 消</el-button>
        <el-button type="primary" @click="replySubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!--    关键词规则弹窗-->
    <el-dialog
        class="rule-dialog"
        :title="dialogRulesTitle"
        width="570px"
        @close="ruleDialogClose"
        :visible.sync="dialogVisibleRule">

      <div class="rule-add-edit-container">
        <div class="rule-label-content">
          <div class="label-title">规则名称</div>
          <div class="label-content">
            <el-input
                type="text"
                class="rule-input"
                placeholder="请输入内容"
                v-model="ruleName"
                maxlength="8"
                show-word-limit
            >
            </el-input>
            <p class="label-tips"><span>*</span>不超过8个字符</p>
          </div>
        </div>
        <div class="rule-label-content">
          <div class="label-title">关键词</div>
          <div class="label-content">
            <el-input
                type="text"
                class="rule-input"
                placeholder="请输入内容"
                v-model="keyword"
            >
            </el-input>
            <div class="add-keywords">
              <span class="wl-btn" @click="addKeywords" >添加关键词</span>
            </div>
          </div>
          <div class="keywords-container">
            <el-tag
                v-for="(keywords, index) in ruleKeywords"
                :key="keywords.keyId"
                closable
                @close="delKeywordsByIndex(index)"
                type="info">
              {{keywords.keyName}}
            </el-tag>
          </div>
        </div>
        <div class="rule-label-content">
          <el-radio-group v-model="ruleContextTypeName" style="margin-bottom: 30px;" @change="ruleContentTypeChange">
            <el-radio-button label="text">文字</el-radio-button>
            <el-radio-button label="image">图片</el-radio-button>
          </el-radio-group>

          <div class="rule-content-container">
            <el-input
                v-if="ruleContextTypeName == 'text'"
                type="textarea"
                rows="10"
                resize="none"
                maxlength="500"
                show-word-limit
                placeholder="请输入内容"
                v-model="ruleContext">
            </el-input>
            <div class="content-image" v-if="ruleContextTypeName == 'image'">
              <div class="upload-container" @click="ruleUpload" v-if="ruleContext == ''">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <input type="file" ref="ruleFileInput" @change="ruleFileChange" style="display: none;">
              </div>
              <div v-else class="img-url">
                <i class="el-icon-circle-close img-del" @click="deRuleImg"></i>
                <img :src="ruleContext" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <span v-if="dialogRuleType == 'edit'" class="dialog-del-btn" @click="delRule"><i class="el-icon-delete"></i>删除规则</span>
        <el-button @click="ruleDialogClose">取 消</el-button>
        <el-button type="primary" @click="ruleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'gzh-reply',
    data() {
      return {
        gzhId: this.$route.query.id,
        replyData: {},
        dialogVisibleReply: false,
        dialogVisibleRule: false,
        dialogReplyType: 'add',
        dialogRuleType: 'add',
        dialogReplyTitle: '添加关注回复',
        dialogRulesTitle: '添加关键词规则',
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
        replyType: 'text',
        replyContent: '',
        rules: [],
        ruleName: '',
        ruleContextTypeName: 'text',
        ruleContext: '',
        keyword:'',
        ruleId:'',
        ruleKeywords: [],
      }
    },
    created() {
      this.getReplyData()
      this.getRulesDta()
    },
    mounted() {

    },
    methods: {
      initData() {
        this.dialogVisibleReply = false;
        this.replyType = 'text'
        this.replyContent = ''
      },
      /**
       * 获取关注回复数据
       */
      getReplyData() {
        this.$http.getReplyAPI({
          gzhId: this.gzhId
        }).then(res => {
          if (res.status == 1) {
            this.replyData = res.data
          }
        })
      },
      /**
       *
       * 获取规则数据
       * */
      getRulesDta() {
        this.$http.getGzhRulesAPI({
          gzhId: this.gzhId
        }).then(res => {
          if (res.status == 1) {
            this.rules = res.data.rules
          }
        })
      },
      editReply() {
        this.replyType = this.replyData.type
        this.replyContent = this.replyData.content
        this.dialogReplyTitle = '编辑关注回复'
        this.dialogVisibleReply = true
        this.dialogReplyType = 'edit'
      },
      addReply() {
        this.dialogReplyTitle = '添加关注回复'
        this.dialogVisibleReply = true
        this.dialogReplyType = 'add'
      },
      /**
       * 文本-图片切换
       * @param val
       */
      replyTypeChange(val) {
        this.replyType = val
        this.replyContent = ''
      },
      replyUpload() {
        this.$refs.replyFileInput.click()
      },
      /**
       * 上传图片
       * @param e
       * @returns {boolean}
       */
      replyFileChange(e) {
        let img = e.target.files[0]
        let type = img.type
        let size = img.size
        if (this.accept.indexOf(type) == -1) {
          this.$message({
            showClose: true,
            message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        if (size > 5242880) {
          this.$message({
            showClose: true,
            message: '请选择5M以内的图片！',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        let formdata = new FormData()
        formdata.set('file', img)
        this.$http.uploadImageAPI(formdata).then(res => {
          if (res.status == 1) {
            this.replyContent = res.data
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      /**
       * 关注回复-删除图片
       * */
      deImg() {
        this.replyContent = ''
      },
      /**
       * 关注回复-取消-确定
       */
      replyDialogClose() {
        this.initData()
      },
      replySubmit() {
        if (this.$utils.u_isEmpty(this.replyContent)) {
          if (this.replyType == 'text') {
            this.$message({
              message: '内容不能为空！',
              type: 'error',
            })
          } else {
            this.$message({
              message: '请先上传图片',
              type: 'error',
            })
          }
          return false
        }
        let postReplyPramas = {
          gzhId: this.gzhId,
          type: this.replyType,
          content: this.replyContent,
        }
        this.$http.editReplyAPI(postReplyPramas).then(res => {
          if (res.status == 1) {
            this.replyDialogClose()
            this.$nextTick(() => {
              this.getReplyData()
            })
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      /***
       *
       * 删除回复
       * */
      delReply(){
        this.$http.delReplyAPI({
          gzhId:this.gzhId
        }).then( res => {
          if(res.status == 1){
            this.replyDialogClose()
            this.$nextTick(() => {
              this.getReplyData()
            })
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }

        })
      },
      /**
       * 规则弹窗关闭
       * */

      ruleDialogClose() {
        this.dialogVisibleRule = false
        this.ruleId = ''
        this.ruleName = ''
        this.ruleContextTypeName = 'text'
        this.ruleContext =''
        this.ruleKeywords = []
      },
      /**
       * 添加关键词规则
       */
      addKeywordsRule() {
        this.dialogVisibleRule = true
        this.dialogRulesTitle = '添加关键词规则'
        this.dialogRuleType = 'add'
      },
      /**
       * 编辑关键词规则
       * @param item
       */
      editRuels(item) {
        this.dialogVisibleRule = true
        this.dialogRuleType = 'edit'
        this.dialogRulesTitle = '编辑关键词规则'
        this.ruleId = item.ruleId
        this.ruleName = item.name
        this.ruleContextTypeName = item.ruleContextTypeName
        this.ruleContext =item.ruleContext
        this.ruleKeywords = item.keyName
      },
      /**
       * 单个删除关键词
       */
      delKeywords(keyId,ruleId) {
        this.$http.delGzhKeywordsAPI({
          gzhId:this.gzhId,
          ruleId:ruleId,
          keyId:keyId,
        }).then( res => {
          if (res.status == 1) {
           this.getRulesDta()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      /**
       * 规则内容类型切换
       */
      ruleContentTypeChange(val){
        this.ruleContextTypeName = val
        this.ruleContext = ''
      },
      /**
       * 规则内容图片上传
       */
      ruleUpload(){
        this.$refs.ruleFileInput.click()
      },
      ruleFileChange(e){
        let img = e.target.files[0]
        let type = img.type
        let size = img.size
        if (this.accept.indexOf(type) == -1) {
          this.$message({
            showClose: true,
            message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        if (size > 5242880) {
          this.$message({
            showClose: true,
            message: '请选择5M以内的图片！',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        let formdata = new FormData()
        formdata.set('file', img)
        this.$http.uploadImageAPI(formdata).then(res => {
          if (res.status == 1) {
            this.ruleContext = res.data
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },

      /**
       * 添加关键词
       */
      addKeywords(){
        if(this.$utils.u_delAllSpace(this.keyword).length == 0){
          return false
        }
        let obj = {
          keyId:this.ruleKeywords.length,
          keyName:this.keyword,
        }
        this.ruleKeywords.push(obj)
        this.$nextTick(() => {
          this.keyword = ''
        })
      },
      /**
       *
       * 删除关键词
       * */
      delKeywordsByIndex(index){
        this.ruleKeywords.splice(index,1)
      },
      /**
       * 删除图片-关键词规则
       */
      deRuleImg(){
        this.ruleContext = ''
      },
      /**
       * 保存规则
       */
      ruleSubmit(){
        let postRuleParams = {}
        let postKeyword = []

        this.ruleKeywords.map( item => {
          postKeyword.push(item.keyName)
        })

        if (this.$utils.u_isEmpty(this.ruleName)) {
          this.$message({
            message: '规则名不能为空！',
            type: 'error',
          })
          return false
        }
        if (postKeyword.length == 0) {
          this.$message({
            message: '关键词不能为空！',
            type: 'error',
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.ruleContext)) {
          if (this.replyType == 'text') {
            this.$message({
              message: '内容不能为空！',
              type: 'error',
            })
          } else {
            this.$message({
              message: '请先上传图片',
              type: 'error',
            })
          }
          return false
        }
        if(this.ruleId == ''){
          postRuleParams ={
            gzhId: this.gzhId,
            type: this.ruleContextTypeName,
            name: this.ruleName,
            keyName: postKeyword,
            ruleContext: this.ruleContext,
            ruleContextTypeName: this.ruleContextTypeName,
          }
        }else {
          postRuleParams = {
            ruleId:this.ruleId,
            gzhId: this.gzhId,
            type: this.ruleContextTypeName,
            name: this.ruleName,
            keyName: postKeyword,
            ruleContext: this.ruleContext,
            ruleContextTypeName: this.ruleContextTypeName,
          }
        }
        this.$http.editGzhRulesAPI(postRuleParams).then( res => {
          if(res.status == 1){
            this.ruleDialogClose()
            this.getRulesDta()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      /**
       * 删除规则
       */
      delRule(){
        this.$http.delGzhRulesAPI({
          'gzhId': this.gzhId,
          'ruleId': this.ruleId
        }).then( res => {
          if(res.status == 1){
            this.ruleDialogClose()
            this.getRulesDta()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss">
  .gzh-reply {
    .reply-container {
      padding: 10px;
      margin-bottom: 10px;

      .reply-text {
        white-space: pre;
        background-color: #f9fafc;
        padding: 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, .2);
      }

      .reply-image {
        width: 280px;
        height: 150px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .rules-container {
      padding: 20px 0 0 0;

      .rules-item {
        font-size: 12px;
        width: 528px;
        border-radius: $mainBorderRadius;
        border: 1px solid rgba(230, 233, 238, 1);
        padding: 15px;
        margin-bottom: 15px;

        .rule-item-title-container {
          display: flex;
          padding: 10px 0 20px;
          margin-bottom: 15px;
          border-bottom: 1px solid #eee;
          align-items: center;

          .rule-edit-btn {
            margin-left: auto;
            color: $mainColor;
            cursor: pointer;
            width: 80px;
          }

          .rule-name {
            padding: 0 10px 0 5px;
          }
        }

        .rule-keywords {
          padding-bottom: 20px;

          span + span {
            margin-left: 10px;
          }
        }

        .rule-content-container {
          padding: 0;

          .rule-text {
            background-color: #f9fafc;
            padding: 20px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, .2);
          }

          .rule-image {
            width: 280px;
            height: 150px;
            margin: 0 auto;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .reply-dialog {
      .reply-content-container {
        .content-text {
          height: 222px;
        }

        .content-image {
          height: 222px;
          background-color: rgba(250, 250, 250, 1);
          border-radius: $mainBorderRadius;
          display: flex;
          align-items: center;

          .img-url {
            width: 80%;
            height: 80%;
            margin: 0 auto;
            position: relative;

            .img-del {
              position: absolute;
              top: -6px;
              right: -6px;
              font-size: 20px;
              cursor: pointer;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }

          .upload-container {
            width: 150px;
            height: 150px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: $mainBorderRadius;
            border: 1px solid #E4E7ED;
            margin: 0 auto;
            font-size: 40px;
            cursor: pointer;

          }
        }
      }
    }

    .rule-dialog {
      .rule-add-edit-container {
        .rule-label-content {
          padding-bottom: 20px;

          .label-title {
            font-size: 14px;
            font-weight: bold;
            padding-bottom: 13px;
            color: #333;
          }

          .label-content {
            display: flex;
            align-items: center;

            .rule-input {
              width: 400px;
            }

            .label-tips {
              color: #999999;
              padding-left: 20px;

              span {
                color: #FD4949;
                padding-right: 3px;
              }
            }
            .add-keywords{
              padding-left: 20px;
            }
          }

          .keywords-container{
            padding: 6px 0 0;
            span{
              margin-right: 5px;
              margin-bottom: 5px;
            }
          }
          .el-radio-button__inner{
            padding: 7px 10px;
          }
          .content-image {
            height: 222px;
            background-color: rgba(250, 250, 250, 1);
            border-radius: $mainBorderRadius;
            display: flex;
            align-items: center;

            .img-url {
              width: 80%;
              height: 80%;
              margin: 0 auto;
              position: relative;

              .img-del {
                position: absolute;
                top: -6px;
                right: -6px;
                font-size: 20px;
                cursor: pointer;
              }

              img {
                width: 100%;
                height: 100%;
              }
            }

            .upload-container {
              width: 150px;
              height: 150px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: $mainBorderRadius;
              border: 1px solid #E4E7ED;
              margin: 0 auto;
              font-size: 40px;
              cursor: pointer;

            }
          }

        }
      }
    }

    .el-dialog__footer{
      .dialog-footer{
        display: inline-block;
        width: 100%;
        .dialog-del-btn{
          float: left;
          line-height: 40px;
          cursor: pointer;
          color: #F47F0D;
          font-size: 12px;
          i{
            margin-right: 5px;
          }
        }

      }
    }

  }
</style>
